module.exports = __webpack_public_path__ + "img/flood_relief_banner_2025.40bdc55e.jpg";